import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
// import { InputText } from "primereact/inputtext";
import { FunctionComponent, useEffect, useState } from "react";
import UserService from "services/users-service";
import { Iusers } from "types/users.type";
import { useNavigate } from "react-router-dom";
import { handlingUrlParams } from "Utils/AppUtils";

interface UserProps {}

const Users: FunctionComponent<UserProps> = () => {
  const navigate = useNavigate();
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [first1, setFirst1] = useState<number>(0);
  // const [currentPage, setCurrentPage] = useState(1);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
  });

  useEffect(() => {
    loadLazyData();
  }, [lazyParams]);

  const loadLazyData = () => {
    setLoading(true);
    UserService.getUsers(
      handlingUrlParams({
        PageNumber: lazyParams.page,
        PageSize: lazyParams.rows,
      })
    )
      .then((response: any) => {
        const getHeaders = response.headers;
        const parsedHeaders = JSON.parse(getHeaders["x-pagination"]);
        setUsersData(response.data);
        setTotalRecords(parsedHeaders.TotalCount);
        setLoading(false);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  const onPage = (event: any) => {
    setFirst1(event.first);
    event["page"] = event.page + 1;
    setLazyParams(event);
  };

  const onSort = (event: any) => {
    setLazyParams(event);
    console.log(event);
  };

  const navigateToAddUsers = () => {
    navigate("add-users");
  };

  const renderUserApps = (rowData: any) => {
    return (
      <>
        <div className="d-flex align-items-center">
          {rowData.customers && rowData.customers.length
            ? rowData.customers[0]?.applications?.map(
                (item: any, index: number) => (
                  <li key={index}>
                    {rowData.customers[0].name} - {item.name} - {item.role}
                  </li>
                )
              )
            : "N/A"}
        </div>
      </>
    );
  };

  const renderFilter = () => {
    return (
      <div className="flex flex-row justify-between flex-row-reverse">
        {/* <div>
          <span className="p-input-icon-left mx-3">
            <i className="pi pi-search" />
            <InputText placeholder="Keyword Search" value="" />
          </span>
        </div> */}
        <Button
          label="Add New User"
          icon="pi pi-plus"
          className="p-button-success  p-button-outlined mr-2"
          onClick={navigateToAddUsers}
        />
      </div>
    );
  };

  const renderAdminStatus = (rowData: Iusers) => {
    return (
      <>
        <div className="flex items-center">
          {rowData.isSuperAdmin === true ? (
            <Button
              label="YES"
              className="p-button-success p-button-outlined"
              style={{ padding: "5px 15px" }}
            />
          ) : (
            <Button
              label="NO"
              className="p-button-warning p-button-outlined"
              style={{ padding: "5px 15px" }}
            />
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <DataTable
        className="shadow-md"
        scrollable
        value={usersData}
        loading={loading}
        stripedRows
        lazy={true}
        paginator={true}
        filterDisplay="menu"
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        dataKey="id"
        rowsPerPageOptions={[10, 20, 50]}
        emptyMessage="No Users found."
        totalRecords={totalRecords}
        rows={lazyParams.rows}
        onPage={onPage}
        onSort={onSort}
        sortOrder={lazyParams.sortOrder}
        header={renderFilter}
        first={first1}
      >
        <Column field="firstName" header="First Name"></Column>
        <Column field="lastName" header="Last Name"></Column>
        <Column field="email" header="User Email"></Column>
        <Column body={renderAdminStatus} header="SuperAdmin"></Column>
        <Column body={renderUserApps} header="Applications"></Column>
      </DataTable>
    </>
  );
};

export default Users;
